var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6322 10.4997C13.6322 12.2322 12.2322 13.6322 10.4997 13.6322C8.76719 13.6322 7.36719 12.2322 7.36719 10.4997C7.36719 8.76719 8.76719 7.36719 10.4997 7.36719C12.2322 7.36719 13.6322 8.76719 13.6322 10.4997Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4994 17.7371C13.5881 17.7371 16.4669 15.9171 18.4706 12.7671C19.2581 11.5334 19.2581 9.45961 18.4706 8.22586C16.4669 5.07586 13.5881 3.25586 10.4994 3.25586C7.41062 3.25586 4.53187 5.07586 2.52812 8.22586C1.74062 9.45961 1.74062 11.5334 2.52812 12.7671C4.53187 15.9171 7.41062 17.7371 10.4994 17.7371Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7263c98bd2aa26a6a76e44c02ebf115c.svg";
export { ForwardRef as ReactComponent };